import { DetailsList, SelectionMode } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import AppContent from "../../Surfaces/AppContent";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import { NumericMoneyFormat } from "../../Utilities/MoneyFormat";
import { netGrossColumn, useNetGross } from "../../Utilities/NetGrossField";

function AddonSold(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [AddonSolds, setAddonSolds] = useState([]);
    const [month, setMonth] = useState(dbDate(new Date()).substr(0, 7));
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/addon/${month}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setAddonSolds(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [month, user.token]);

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns( [
            {
                key: 'addon',
                name: 'Dodatek',
                ariaLabel: 'Nazwa Dodatku',
                fieldName: 'addon',
                minWidth: 210,
                isRowHeader: true,
                isResizable: true,
            },
            {
                key: 'project',
                name: 'Projekt',
                ariaLabel: 'Nazwa Projektu',
                fieldName: 'project',
                minWidth: 210,
                isResizable: true,
            },
            {
                key: 'venture',
                name: 'Kontrakt',
                ariaLabel: 'Nazwa Kontraktu',
                fieldName: 'venture',
                minWidth: 210,
                isResizable: true,
            },
            {
                key: 'invoice_number',
                name: 'Faktura',
                ariaLabel: 'Numer Faktury',
                fieldName: 'invoice_number',
                minWidth: 150,
                isResizable: true,
            },
            {
                minWidth: 100,
                ...netGrossColumn('', 'total', 'Wartość ')
            },
            {
                key: 'commission',
                name: 'Prowizja',
                ariaLabel: 'Prowizja',
                fieldName: 'commission',
                minWidth: 100,
                isResizable: true,
            }
        ]);
    }, [netGross]);
    let sum = AddonSolds.reduce((pv, cv) => {
        if (pv.commission !== undefined) {
            pv = parseFloat(pv.commission);
        }
        return pv + parseFloat(cv.commission);
    }, 0);
    sum = NumericMoneyFormat(sum);
    return (
        <AppContent title={`Sprzedane dodatki`} subtitle={'Raport'}>
            <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} />
            <DetailsList items={AddonSolds} columns={columns} selectionMode={SelectionMode.none}/>
            <h4>Prowizja razem {sum} zł</h4>
        </AppContent>
    );
}

export default AddonSold;